export default __webpack_public_path__ + "static/media/a1-4-0.bec4394d.jpg";